import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { globalTheme } from "../../styles";
import { getIconByValue } from "../Flags/Flags";
import { CA_ORDER_BASE_URL } from "../../constants";

// Memoise cell level component to avoid unnecessary re-renders. This helps enhancing performance improvements
export const OrdersIdCell = React.memo((params: CustomCellRendererProps) => {
  const { data } = params;
  const timestamp = data.shipByDateTime ? new Date(data.shipByDateTime).getTime() : null;

  const [timeDifference, setTimeDifference] = useState(0);
  const [timerLabel, setTimerLabel] = useState("");
  const [flagTitle, setFlagTitle] = useState<string>("");

  useEffect(() => {
    if (!timestamp) {
      setTimerLabel("Ship by date not available");
      return;
    }

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = timestamp - now;

      // Calculate days, hours, minutes, and seconds
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      //const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // Determine if it's remaining or expired
      if (difference > 0) {
        setTimerLabel(`Due in ${days}d ${hours}h ${minutes}m`);
      } else {
        setTimerLabel(`Overdue ${-days}d ${-hours}h ${-minutes}m ago`);
      }

      setTimeDifference(difference);
    }, 1000);

    return () => clearInterval(interval);
  }, [timestamp]);

  useEffect(() => {
    if (data?.flagType === "ITEM_COPIED") {
      setFlagTitle("Item Copied");
    } else if (data?.flagType === "EXCLAMATION_POINT") {
      setFlagTitle("Issue With Customer");
    } else if (data?.flagType === "RED_FLAG") {
      setFlagTitle("Red Flag");
    } else if (data?.flagType === "QUESTION_MARK") {
      setFlagTitle("Local Pickup");
    } else if (data?.flagType === "NOT_AVAILABLE") {
      setFlagTitle("Not Available");
    } else if (data?.flagType === "PRICE") {
      setFlagTitle("Price");
    } else if (data?.flagType === "YELLOW_FLAG") {
      setFlagTitle("Yellow Flag");
    } else if (data?.flagType === "GREEN_FLAG") {
      setFlagTitle("To be Processed");
    } else if (data?.flagType === "BLUE_FLAG") {
      setFlagTitle("Issue to be noticed");
    }
  }, [data]);

  return (
    <Stack alignItems="center" spacing={2}>
      {data?.orderIds?.map((item, key) => (
        <Stack direction="row" alignItems="center" spacing={1} key={key}>
          {data?.flagType && data?.flagType !== "NO_FLAG" && (
            <Tooltip title={flagTitle || "No flag type"}>{getIconByValue(data?.flagType)}</Tooltip>
          )}
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Typography
              variant="body2"
              color={globalTheme.primaryColor}
              component="a"
              href={`${CA_ORDER_BASE_URL}${item}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item}
            </Typography>
            <Typography variant="body2" color={globalTheme.primaryColor}>
              {data?.siteOrderIDs?.[key]}
            </Typography>
          </Box>
        </Stack>
      ))}
      <Stack alignItems="center" spacing={1}>
        {data?.pickingDetail?.packingStationId && (
          <Typography variant="body2">
            <span style={{ color: "black" }}>Packing Station: </span>
            <span style={{ color: globalTheme.primaryColor }}>{data?.pickingDetail?.packingStationId}</span>
          </Typography>
        )}
        <Typography
          variant="body2"
          color={timeDifference > 3600000 ? globalTheme.primaryColor : timeDifference > 0 ? globalTheme.orange : globalTheme.red}
        >
          {timerLabel}
        </Typography>
      </Stack>
    </Stack>
  );
});
